import { useEffect, useState } from 'react';

import { notificationPermission, PushPermission } from 'lib/webPush';

/**
 * The site's notification permission as the browser reports it. `Notification.permission`
 * is a plain property with no change event, so it is re-read whenever the page comes back into view —
 * the moments a user is likeliest to have just changed it in the browser's site settings or another
 * tab. `setPermission` lets the enable flow store the prompt's answer directly.
 */
export function useNotificationPermission({ active = true }: { active?: boolean } = {}) {
  const [permission, setPermission] = useState<PushPermission>(() => notificationPermission());

  useEffect(() => {
    if (!active) return undefined;
    const refresh = () => setPermission(notificationPermission());
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [active]);

  return { permission, setPermission };
}
